import amenity_icon_sprite from "assets/amenity-icons-sprite.svg";
import iconNull from "assets/icons/svg/icon-null.svg";

const AmenityIcon = ({ id }) => {
	const amenityIconMap = {
		8: <Icon icon="tv" />,
		9: <Icon icon="tv" />,
		10: <Icon icon="breakfast" />,
		11: <Icon icon="wifi" />,
		12: <Icon icon="ac" />,
		54: <Icon icon="heater" />,
		14: <Icon icon="100Pet" />,
		15: <Icon icon="bath-tub" />,
		16: <Icon icon="child" />,
		17: <Icon icon="old-man" />,
		18: <Icon icon="guest-allowed" />,
		19: <Icon icon="paw" />,
		20: <Icon icon="two-people" />,
		21: <Icon icon="rainbow" />,
		22: <Icon icon="vegetarian" />,
		23: <Icon icon="alcohol" />,
		24: <Icon icon="cigarette" />,
		25: <Icon icon="dome-lid" />,
		26: <Icon icon="elevator-in-building" />,
		28: <Icon icon="washing-machine" />,
		29: <Icon icon="hair-dryer" />,
		30: <Icon icon="genset" />,
		31: <Icon icon="parking" />,
		32: <Icon icon="corporate-guest-only" />,
		33: <Icon icon="family-only" />,
		34: <Icon icon="women-only" />,
		35: <Icon icon="driver" />,
		36: <Icon icon="swimming-pool" />,
		37: <Icon icon="towel" />,
		38: <Icon icon="towel" />,
		39: <Icon icon="fork-and-spoon" />,
		40: <Icon icon="shoots" />,
		41: <Icon icon="cooker" />,
		42: <Icon icon="inverter" />,
		// 41: <Icon icon="dome-lid" />,
		43: <Icon icon="dome-lid-crossed" />,
		44: <Icon icon="proposal-or-anniversary" />,
		45: <Icon icon="pre-wedding-shoots" />,
		46: <Icon icon="small-functions-weddings" />,
		47: <Icon icon="big-weddings" />,
		48: <Icon icon="anniversary-celebrations" />,
		49: <Icon icon="milestone-birthdays" />,
		50: <Icon icon="team-offsites" />,
		51: <Icon icon="strategic-meetings-gatherings" />,
		52: <Icon icon="safe" />,
		53: <Icon icon="fire-extinguisher" />,
		13: <Icon icon="ac" />,
		55: <Icon icon="wifi" />,
		58: <Icon icon="massage-at-additional-charges" />,
		59: <Icon icon="tv" />,
		60: <Icon icon="tv" />,
		61: <Icon icon="heater" />,
		62: <Icon icon="tv" />,
		63: <Icon icon="game" />,
		64: <Icon icon="cctv" />,
		65: <Icon icon="dome-lid" />,
		66: <Icon icon="dome-lid" />,
		85: <Icon icon="lawn" />,
		78: <Icon icon="ct" />,
		82: <Icon icon="wifi" />,
		79: <Icon icon="library" />,
	};

	// towels-toiletries

	return amenityIconMap[id] ? (
		amenityIconMap[id]
	) : (
		<img width="20" height="20" src={iconNull} alt="null" />
	);
};

export default AmenityIcon;

const Icon = (props) => (
	<svg viewBox="0 0 6 6" className={`icon icon-${props.icon}`} width="24">
		<use xlinkHref={`${amenity_icon_sprite}#${props.icon}`} />
	</svg>
);
